import {registerApplication, start, LifeCycles} from "single-spa";
import TagManager from "react-gtm-module";
import {injectContentsquareScript} from "@contentsquare/tag-sdk";

type UserDataType = string | number | null;

export interface UserData {
  userId?: UserDataType;
  orgId?: UserDataType;
  orgType?: UserDataType;
  orgName?: UserDataType;
  roleId?: UserDataType;
  roleName?: UserDataType;
  sessionId?: UserDataType;
  clearUserData?: boolean;
}

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GOOGLE_ANALYTICS_GTM_ID || "",
  auth: process.env.REACT_APP_GOOGLE_ANALYTICS_GTM_AUTH || "",
  preview: process.env.REACT_APP_GOOGLE_ANALYTICS_GTM_PREVIEW || ""
};

if (tagManagerArgs.gtmId) {
  TagManager.initialize(tagManagerArgs);
}
// Listen for user data updates from microfrontends
window.addEventListener("userDataUpdate", (event: Event) => {
  const customEvent = event as CustomEvent<UserData>;
  const {
    userId,
    orgId,
    orgType,
    orgName,
    roleId,
    roleName,
    sessionId,
    clearUserData
  } = customEvent.detail;

  // Prepare dataLayer object
  const dataLayerPayload = clearUserData
    ? {
        user_id: null,
        userId: null,
        orgId: null,
        orgType: null,
        orgName: null,
        roleId: null,
        roleName: null,
        sessionId: null
      } // Clear values
    : {
        user_id: userId,
        userId,
        orgId,
        orgType,
        orgName,
        roleId,
        roleName,
        sessionId
      }; // Set values
  // Push to GTM dataLayer
  TagManager.dataLayer({dataLayer: dataLayerPayload});
});

injectContentsquareScript({
  siteId: process.env.REACT_APP_CONTENT_SQUARE_SITE_ID,
  async: true, // Optional: Set to false to wait for script execution until after document parsing.
  defer: false // Optional: Set to true to defer script execution after document parsing.
});

const appNames = {
  taas: "/taas",
  hub: "/hub",
  tradein: "/tradein"
};

registerApplication({
  name: "@wabash/marketplace-ui",
  app: () => System.import<LifeCycles>("@wabash/marketplace-ui"),
  activeWhen: (location) =>
    !Object.values(appNames).some((path) => location.pathname.startsWith(path))
});

registerApplication({
  name: "@wabash/taas-ui",
  app: () => System.import<LifeCycles>("@wabash/taas-ui"),
  activeWhen: (location) => location.pathname.startsWith(appNames.taas)
});

registerApplication({
  name: "@wabash/dashboard-ui",
  app: () => System.import<LifeCycles>("@wabash/dashboard-ui"),
  activeWhen: (location) => location.pathname.startsWith(appNames.hub)
});

registerApplication({
  name: "@wabash/tradein-ui",
  app: () => System.import<LifeCycles>("@wabash/tradein-ui"),
  activeWhen: (location) => location.pathname.startsWith(appNames.tradein)
});

start();
